module.exports = __webpack_public_path__ + "img/pr-7.b2a3b595.png";